<template>
  <span class="countdown">
    <span v-show="days"><span class="b number textColor">{{ days }}</span> {{ $tc('vinylContest.day', days) }}</span>
    <span v-show="hours"><span class="b number textColor">{{ hours }}</span> {{ $tc('vinylContest.hour', hours) }}</span>
    <span class="b number textColor">{{ minutes }}</span> {{ $tc('vinylContest.minute', minutes) }}
  </span>
</template>

<script>
  export default {
    name: 'countdown',
    props: {
      end: {
        required: true
      }
    },
    data () {
      return {
        days: 0,
        hours: 0,
        minutes: 0
      }
    },
    mounted () {
      setInterval(this.updateDateTime, 1000)
    },
    methods: {
      updateDateTime () {
        let now = new Date().getTime()
        let final = new Date(this.end * 1000)
        let distance = final - now
        this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
        this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/Countdown.vue